import { Input } from '@angular/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons';
import { PaymentsService } from 'src/app/services/payments.service';
import * as html2pdf from 'html2pdf.js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-payment-to-PDF',
  templateUrl: './payment-to-PDF.component.html',
  styleUrls: ['./payment-to-PDF.component.scss'],
})
export class PaymentToPDFComponent implements OnInit {
  @Input() paymentId?: any[];
  @Input() popoverOption?: boolean = false;

  payment: any;
  totalRent: number = 0;

  serviceStatus = [];

  frontOrBack = false;
  newWindowHtml: string;
  iconDownload = faFileArrowDown;
  isLoaded: boolean = true;

  constructor(
    public paymentService: PaymentsService,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {}

  closeModal() {
    this.modalService.dismissAll();
  }

  openModal(template) {
    this.isLoaded = false;
    
    console.log('🔍 Iniciando generación de PDF para pago ID:', this.paymentId);
    
    // Obtener los servicios del pago primero para verificar que existen
    this.paymentService.getRequirementsForPayment(this.paymentId).subscribe(
      (requirements: any) => {
        console.log('📋 Servicios obtenidos para el PDF:', requirements);
        console.log('📊 Cantidad de servicios:', Array.isArray(requirements) ? requirements.length : 0);
        
        // Obtener la vista del recibo (el backend debería incluir los servicios automáticamente)
        this.paymentService.getPaymentReceiptView(this.paymentId).subscribe(
          (payment: any) => {
            console.log('✅ Vista del recibo obtenida exitosamente');
            // Si la respuesta es exitosa, el HTML debería estar en el body
            if (payment && typeof payment === 'string') {
              this.newWindowHtml = payment;
            }
            this.generatePDF();
          },
          (error) => {
            console.log('⚠️ Respuesta del backend (puede ser normal si devuelve HTML en error):', error);
            // El backend NestJS a veces devuelve el HTML en error.error.text cuando es un error 200 con texto
            if (error.error && error.error.text) {
              console.log('📄 HTML obtenido del error.error.text');
              this.newWindowHtml = error.error.text;
              // Verificar si el HTML incluye información de servicios
              this.verifyServicesInHTML(this.newWindowHtml, requirements);
              this.generatePDF();
            } else if (error.error && typeof error.error === 'string') {
              console.log('📄 HTML obtenido directamente del error.error');
              this.newWindowHtml = error.error;
              this.verifyServicesInHTML(this.newWindowHtml, requirements);
              this.generatePDF();
            } else {
              console.error('❌ Error al obtener la vista del recibo:', error);
              this.isLoaded = true;
            }
          },
        );
      },
      (error) => {
        console.warn('⚠️ No se pudieron obtener los servicios del pago:', error);
        console.warn('⚠️ Continuando con la generación del PDF sin verificar servicios...');
        // Continuar con la generación del PDF aunque no se obtengan los servicios
        this.paymentService.getPaymentReceiptView(this.paymentId).subscribe(
          (payment: any) => {
            if (payment && typeof payment === 'string') {
              this.newWindowHtml = payment;
            }
            this.generatePDF();
          },
          (error) => {
            if (error.error && error.error.text) {
              this.newWindowHtml = error.error.text;
              this.generatePDF();
            } else if (error.error && typeof error.error === 'string') {
              this.newWindowHtml = error.error;
              this.generatePDF();
            } else {
              console.error('Error al obtener la vista del recibo:', error);
              this.isLoaded = true;
            }
          },
        );
      },
    );
  }

  private verifyServicesInHTML(html: string, requirements: any[]) {
    if (!html || !requirements || requirements.length === 0) {
      console.log('ℹ️ No hay servicios para verificar en el HTML');
      return;
    }
    
    // Verificar si el HTML contiene referencias a los servicios
    const hasServices = html.toLowerCase().includes('servicio') || 
                       html.toLowerCase().includes('requirement') ||
                       html.toLowerCase().includes('requerimiento');
    
    console.log('🔍 Verificación de servicios en HTML:');
    console.log('  - HTML contiene referencias a servicios:', hasServices);
    console.log('  - Cantidad de servicios esperados:', requirements.length);
    
    if (!hasServices && requirements.length > 0) {
      console.warn('⚠️ ADVERTENCIA: El HTML del recibo no parece contener información de servicios');
      console.warn('⚠️ Esto sugiere que el backend no está incluyendo los servicios en el PDF');
    }
  }

  private generatePDF() {
    if (!this.newWindowHtml) {
      console.error('❌ No se obtuvo el HTML del recibo');
      this.isLoaded = true;
      return;
    }

    this.paymentService
      .getPaymentReceipt(this.paymentId)
      .subscribe(
        (payment: any) => {
          console.log('✅ PDF generado exitosamente');
          var newWind = open();
          newWind.document.write(this.newWindowHtml);
          this.isLoaded = true;
        },
        (error) => {
          console.error('❌ Error al generar el PDF:', error);
          // Intentar abrir el HTML de todas formas si lo tenemos
          if (this.newWindowHtml) {
            console.log('⚠️ Intentando abrir HTML directamente...');
            var newWind = open();
            newWind.document.write(this.newWindowHtml);
          }
          this.isLoaded = true;
        },
      );
  }
}
